var React = require('react');

function Factor1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.6938 4.12089L14.9773 0.314016C14.5736 -0.0994638 13.9055 -0.0994638 13.5018 0.314016C13.0982 0.727497 13.0982 1.41188 13.5018 1.82536L15.4366 3.80721H9.70183C4.35678 3.80721 0 8.25569 0 13.745V20.931C0 21.5156 0.47326 22.0003 1.04396 22.0003C1.61465 22.0003 2.08791 21.5298 2.08791 20.931V13.745C2.08791 9.4391 5.51209 5.9459 9.70183 5.9459H15.4366L13.5018 7.9135C13.0982 8.32698 13.0982 9.01136 13.5018 9.42484C13.7106 9.63871 13.9751 9.73851 14.2396 9.73851C14.504 9.73851 14.7685 9.63871 14.9773 9.42484L18.6938 5.61797C19.0974 5.20449 19.0974 4.53437 18.6938 4.12089Z","fill":"#6F16FF"}));
}

Factor1.defaultProps = {"width":"19","height":"22","viewBox":"0 0 19 22","fill":"none"};

module.exports = Factor1;

Factor1.default = Factor1;
